import { createSelector } from 'reselect'

import { selectQBRDocumentFormData } from './selectQBRDocumentFormData'
import { selectQbrSelectedPeriod } from './selectQbrSelectedPeriod'

export const selectQbrSelectedPeriodsWithPercentLabel = createSelector(
  [selectQBRDocumentFormData, selectQbrSelectedPeriod],
  (document, period) => {
    if (!document) {
      return { quartersLabel: '', percentage: 0 }
    }

    const quartersLabel = period.fQuarters.map(({ fQuarter }) => `Q${fQuarter}`).join(',')
    if (document.DocumentHideUtD === 1) {
      return { quartersLabel: '', percentage: 0 }
    }

    const percentage = document.DocumentGeneratedDateQuarterPercent * 100

    return { quartersLabel, percentage }
  }
)
